import { BulletPointsType } from './types';
import './index.scss';

const BulletPoints = ({ numPoints, activeIndex = numPoints - 1, onClick }: BulletPointsType) => {
    return (
        <div className='container'>
            {Array.from({ length: numPoints }).map((_, index) => (
                <div
                    key={index}
                    className={`container__bullet-point${
                        index === activeIndex ? ' container__bullet-point--active' : ''
                    }`}
                    onClick={() => onClick && onClick(index)}
                />
            ))}
        </div>
    );
};

export default BulletPoints;
